import { render, staticRenderFns } from "./InsurerInfoForm.vue?vue&type=template&id=56ae6034&"
import script from "./InsurerInfoForm.vue?vue&type=script&lang=js&"
export * from "./InsurerInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports